/**
 * 장례식장 표시명 유틸.
 *
 * parlors_detail.json의 companyname에는 검색 대응용 별칭이 괄호로 병기돼 있다.
 * 1,186곳 중 83곳이 해당한다.
 *
 *   고대안암병원장례식장(안암고대병원장례식장, 고대병원장례식장)
 *   교원예움 아산장례식장 (구. 신정장례문화원)
 *
 * 이 값이 그대로 CTA나 카드에 들어가면 버튼 한 줄을 훌쩍 넘긴다.
 * parlor_request_info 쿠키도 companyname을 가공 없이 저장하므로(ParlorQuotationRequest)
 * 쿠키에서 읽은 값에도 똑같이 적용해야 한다.
 */

/**
 * 문자열 끝에서 닫히는 괄호 그룹만 별칭으로 본다.
 *
 * 첫 괄호 이후를 통째로 자르면 이름 중간에 괄호가 있는 곳이 망가진다.
 *   남원 엠지(MG)새마을금고 장례식장  -> "남원 엠지"    (X)
 *   에스엠(SM)상조온요양병원장례식장   -> "에스엠"       (X)
 * 끝에서 닫히는 경우만 제거하면 위 두 곳은 원형을 유지한다.
 */
const TRAILING_ALIAS = /\s*[(（][^)）]*[)）]\s*$/;

/**
 * 이름 앞에 붙는 법인격 표기. 별칭이 아니라 접두사라 뒤쪽을 남겨야 한다.
 *   (주)국화원전문장례식장영대병원영천지점 -> "국화원전문장례식장영대병원영천지점"
 */
const LEADING_ENTITY = /^\s*[(（](주|재|사|유|합)[)）]\s*/;

/**
 * 병기된 별칭을 제거한 표시용 장례식장명을 돌려준다.
 *
 * @param companyname - parlors_detail.json의 companyname 또는 parlor_request_info 쿠키의 parlorName
 * @returns 표시용 이름. 입력이 문자열이 아니거나 결과가 비면 빈 문자열
 */
export function toParlorDisplayName(companyname: string | undefined | null): string {
  if (typeof companyname !== "string") return "";
  const stripped = companyname.replace(LEADING_ENTITY, "").replace(TRAILING_ALIAS, "").trim();
  // 이름 전체가 괄호였던 경우 빈 문자열이 되므로 원본으로 되돌린다
  return stripped || companyname.trim();
}
